import { render, staticRenderFns } from "./BoxInfos.vue?vue&type=template&id=63100992&scoped=true&"
import script from "./BoxInfos.vue?vue&type=script&lang=js&"
export * from "./BoxInfos.vue?vue&type=script&lang=js&"
import style1 from "./BoxInfos.vue?vue&type=style&index=1&id=63100992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63100992",
  null
  
)

export default component.exports